import { Box } from '@mui/material'
import React from 'react'
import TripChart from './TripChart'

const LeftSection = (props) => {
    const { bkgDeatails, filterOpt, selectedSeat, setSelectedSeat = () => { },
        handleResetTripData = () => { },
        setBkgDetails = () => { },
        setFilterOpt = () => { },
        showLogoHeader = false,
    } = props;
    return (
        <Box className='left_Section'>
            <TripChart bkgDeatails={bkgDeatails} filterOpt={filterOpt} selectedSeat={selectedSeat} setSelectedSeat={setSelectedSeat}
                handleResetTripData={handleResetTripData}
                setBkgDetails={setBkgDetails}
                setFilterOpt={setFilterOpt}
                showLogoHeader={showLogoHeader}

            />
        </Box>
    )
}

export default LeftSection